import React from 'react';
import logo from '../assets/images/logo.png';
import phoneIcon from '../assets/images/phonenumbericon.svg';
import whatsappIcon from '../assets/images/whatsappicon.svg';
import callbackIcon from '../assets/images/requestcallback.svg';
import facebookIcon from '../assets/images/facebook.svg';
import instagramIcon from '../assets/images/instagram.svg';
import xIcon from '../assets/images/x.svg';
import locationIcon from '../assets/images/location.svg';
import contactPhoneIcon from '../assets/images/phone.svg';
import emailIcon from '../assets/images/email.svg';

const Footer = () => {
return (
<footer className="footer">
{/* Contact CTA */}
<div className="frame">
<div className="container" style={{ maxWidth: '1400px' }}>
<div className="title-section text-center">
<h2 className="fw-bold text-white display-5 mb-4">
Ready to keep your property in perfect condition?
</h2>
<p className="text-secondary fs-5 mx-auto" style={{ maxWidth: '720px' }}>
Contact us today to discuss your property maintenance needs and learn how our service credits system can provide you peace of mind.
</p>
</div>
<div className="d-flex flex-wrap justify-content-center gap-3 w-100 mt-4">
  <a href="tel:+919633718181" className="btn footer-primary-btn d-flex align-items-center justify-content-center gap-2 text-decoration-none">
    <img src={phoneIcon} alt="Phone" width="20" height="20" />
    <span>+91 96337 18181</span>
  </a>

  <a
    href="https://wa.me/919633718181"
    target="_blank"
    rel="noopener noreferrer"
    className="btn footer-whatsapp-btn d-flex align-items-center justify-content-center gap-2"
  >
    <img src={whatsappIcon} alt="WhatsApp Us" width="20" height="20" />
    <span>WhatsApp Us</span>
  </a>

  <button className="btn footer-outline-btn d-flex align-items-center justify-content-center gap-2">
    <img src={callbackIcon} alt="Callback" width="20" height="20" />
    <span>Request a Callback</span>
  </button>
</div>
</div>
</div>

<div className="container" style={{ maxWidth: '1400px' }}>
<div className="row footer-widgets g-0">
  {/* Widget 1 - Logo + Socials */}
  <div className="col-6 col-lg-3 d-flex flex-column ">
Rest Assured
    <p className="mb-3 text-secondary">
      Your trusted partner for property maintenance and home services in Kerala, making sure your property is well taken care of.
    </p>

    <div className="d-flex gap-3 mt-auto">
      <img src={facebookIcon} alt="Facebook" width={36} height={36} />
      <img src={instagramIcon} alt="Instagram" width={36} height={36} />
      <img src={xIcon} alt="X (Twitter)" width={36} height={36} />
    </div>
  </div>

  {/* Widget 2 - Company Info */}
  <div className="col-6 col-lg-3 d-flex flex-column">
    <h5 className="mb-3 fw-semibold">Company</h5>
    <ul className="nav flex-column">
      <li className="nav-item"><a className="nav-link" href="#">Our Services</a></li>
      <li className="nav-item"><a className="nav-link" href="#">How It Works</a></li>
      <li className="nav-item"><a className="nav-link" href="#">Pricing</a></li>
      <li className="nav-item"><a className="nav-link" href="#">FAQ</a></li>
    </ul>
  </div>

  {/* Widget 3 - Services */}
  <div className="col-6 col-lg-3 d-flex flex-column ">
    <h5 className="mb-3 fw-semibold">Our Services</h5>
    <ul className="nav flex-column ">
      <li className="nav-item "><a className="nav-link" href="#">Home Cleaning</a></li>
      <li className="nav-item"><a className="nav-link" href="#">Plumbing</a></li>
      <li className="nav-item"><a className="nav-link" href="#">Electrical Repairs</a></li>
      <li className="nav-item"><a className="nav-link" href="#">Pest Control</a></li>
      <li className="nav-item"><a className="nav-link" href="#">Painting</a></li>
    </ul>
  </div>

  {/* Widget 4 - Contact */}
  <div className="col-6 col-lg-3 d-flex flex-column">
    <h5 className="mb-3 fw-semibold">Contact Us</h5>
    <p className="mb-2 text-secondary">
    <img src={contactPhoneIcon} alt="Phone" width="20" height="20" className="me-2" />
    <a href="tel:+919633718181" className="h6 fw-light ms-2 text-secondary text-decoration-none">+91 96337 18181</a>
      <span className="d-block small text-secondary">(9:AM to 8:PM IST)</span>
    </p>
    <p className="mb-0 text-secondary">
    <img src={emailIcon} alt="Location" width="20" height="20" className="me-2" />
      <span className="h6 fw-light ms-2 text-secondary">info@restassured.com</span>
    </p>
    <p className="mb-2 mt-2 d-flex align-items-start">
      <img src={locationIcon} alt="Location" width="20" height="20" className="me-2 mt-1" />
      <span className="text-secondary">Asset Silver Swan, Aluva, Ernakulam, Kerala, India - 683101</span>
    </p>

  </div>
</div>
</div>

<hr className="mt-4 mb-0" />

{/* Bottom Footer */}
<div className="py-3">
<div className="container px-0">
<div className="d-flex justify-content-center align-items-center py-3 text-center">
<div className="text-secondary text-primary-hover">
Copyrights ©2025 RestAssured. All rights reserved.{' '}
</div>
</div>
</div>
</div>
</footer>
);
};

export default Footer;
